var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJobCardHistory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0946 2.39844H0.5V16.6484H16.5926",
    stroke: "#3D3D3D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66211 11.3984H9.1486",
    stroke: "#3D3D3D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66211 8.39844H6.44589",
    stroke: "#3D3D3D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0605 15.1719L23.3474 16.0045L22.5471 15.2555",
    stroke: "#3D3D3D",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3214 17.7326C21.7635 18.3156 21.0293 18.6785 20.244 18.7593C19.4587 18.8401 18.6709 18.6338 18.0148 18.1756C17.3588 17.7174 16.8751 17.0356 16.6461 16.2465C16.4172 15.4573 16.4572 14.6096 16.7593 13.8479C17.0614 13.0861 17.607 12.4573 18.303 12.0688C18.999 11.6803 19.8024 11.556 20.5763 11.7172C21.3502 11.8783 22.0466 12.3149 22.547 12.9525C23.0474 13.5902 23.3207 14.3894 23.3203 15.214",
    stroke: "#3D3D3D",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1484 13.8281V15.8081H21.0431",
    stroke: "#3D3D3D",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 9.64844L20.5 7.64844",
    stroke: "#3D3D3D",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 11.1484L20.5 8.64844",
    stroke: "#3D3D3D",
    strokeLinecap: "square"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5995 10.2369L15.2399 9.68993C15.6274 9.56093 15.8209 9.49643 16.0029 9.40993C16.2176 9.30729 16.4206 9.18173 16.6084 9.03542C16.7673 8.91142 16.9118 8.76692 17.2003 8.47841L21.4607 4.21835L21.9242 3.75485C22.2929 3.38612 22.5 2.88603 22.5 2.36458C22.5 1.84312 22.2929 1.34303 21.9242 0.974306C21.5555 0.605584 21.0554 0.398438 20.534 0.398438C20.0125 0.398437 19.5125 0.605584 19.1438 0.974306L18.6803 1.43781M18.6803 1.43781C18.6803 1.43781 18.7383 2.42283 19.6072 3.29134C20.4762 4.16035 21.4607 4.21835 21.4607 4.21835M13.5995 10.2369L13.1985 10.3709C13.105 10.4023 13.0046 10.4069 12.9087 10.3844C12.8127 10.3618 12.7249 10.3129 12.6552 10.2432C12.5855 10.1735 12.5366 10.0857 12.5141 9.98974C12.4915 9.89377 12.4962 9.7934 12.5275 9.69993L12.661 9.29942L13.208 7.6589C13.337 7.2719 13.4015 7.07789 13.488 6.89589C13.5906 6.68114 13.7162 6.47812 13.8624 6.29038C13.9864 6.13138 14.1309 5.98688 14.4194 5.69787L18.6803 1.43781M12.661 9.29942L13 9.89844L13.5995 10.2369",
    stroke: "#3D3D3D",
    strokeWidth: 0.8
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobCardHistory);
export default __webpack_public_path__ + "static/media/Job_Card_History.76e976ba332450fa849bcbfbda0b0ec2.svg";
export { ForwardRef as ReactComponent };